import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.394 18.309h5.212m2.743 3.291H6.65a1.097 1.097 0 0 1-1.097-1.097v-2.931c0-.234.075-.462.214-.65l3.147-4.271a1.1 1.1 0 0 0 0-1.302L5.768 7.08a1.1 1.1 0 0 1-.214-.651v-2.93c0-.607.491-1.098 1.097-1.098h10.423c.606 0 1.097.491 1.097 1.097V6.45c0 .221-.066.437-.191.62l-2.934 4.288c-.264.385-.255.895.022 1.27l3.164 4.294c.139.189.214.417.214.651v2.93c0 .607-.492 1.098-1.098 1.098"
    />
  </svg>
);
export default SvgHourglass02;
